var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.25C1.15 15.25 0.854 15.129 0.612 14.887C0.370667 14.6457 0.25 14.35 0.25 14C0.25 13.65 0.370667 13.3543 0.612 13.113C0.854 12.871 1.15 12.75 1.5 12.75C1.85 12.75 2.146 12.871 2.388 13.113C2.62933 13.3543 2.75 13.65 2.75 14C2.75 14.35 2.62933 14.6457 2.388 14.887C2.146 15.129 1.85 15.25 1.5 15.25ZM5.25 14.75V13.25H17.75V14.75H5.25ZM1.5 9.25C1.15 9.25 0.854 9.129 0.612 8.887C0.370667 8.64567 0.25 8.35 0.25 8C0.25 7.65 0.370667 7.35433 0.612 7.113C0.854 6.871 1.15 6.75 1.5 6.75C1.85 6.75 2.146 6.871 2.388 7.113C2.62933 7.35433 2.75 7.65 2.75 8C2.75 8.35 2.62933 8.64567 2.388 8.887C2.146 9.129 1.85 9.25 1.5 9.25ZM5.25 8.75V7.25H17.75V8.75H5.25ZM1.5 3.25C1.15 3.25 0.854 3.129 0.612 2.887C0.370667 2.64567 0.25 2.35 0.25 2C0.25 1.65 0.370667 1.354 0.612 1.112C0.854 0.870667 1.15 0.75 1.5 0.75C1.85 0.75 2.146 0.870667 2.388 1.112C2.62933 1.354 2.75 1.65 2.75 2C2.75 2.35 2.62933 2.64567 2.388 2.887C2.146 3.129 1.85 3.25 1.5 3.25ZM5.25 2.75V1.25H17.75V2.75H5.25Z",
    fill: "#B8135D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f9ff38ba71704da88dbab0b27e49807f.svg";
export { ForwardRef as ReactComponent };